// eslint-disable-next-line import/no-unresolved
import { Content } from '@plone/types';
import { SchemaModifier } from '../types';
import { generateSchema } from '../SchemaGeneration';

const topicModifier: SchemaModifier = (
  content,
  main,
  parts,
  state,
  partial,
) => {
  if (content?.parent_topics?.length) {
    main['inDefinedTermSet'] = generateSchema({
      type: content.parent_topics[0]['@type'],
      content: content.parent_topics[0] as Content,
      state,
      partial: true,
    });
  }
};

export default topicModifier;
